import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let Fireworks = class Fireworks extends Vue {
};
Fireworks = __decorate([
    Component({
        data() {
            return {};
        },
    })
], Fireworks);
export default Fireworks;
